
import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './menu.css';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import history from "../../auth/history";
import { setAepsSection } from "../../redux/aeps/aeps.action";
import tokenErrorHandler from "../tokenErrorHandler";
import { setRetailerBalanceVal } from "../../redux/misc-data/misc-data.action";

const httpClient = axios.create();

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: '',
            retailerBalance: 0
        }
    }

    componentDidMount() {

        if (this.props.retailerBalanceShow == 'yes') {
            this.loadRetailerBalance();
        }

    }
    componentWillUnmount() {
    }

    goToAeps = (e) => {
        e.preventDefault();
        store.dispatch(setAepsSection('txnHistory'));

        setTimeout(() => {
            var gotoAepsBtn = document.getElementById('gotoAepsBtn');
            gotoAepsBtn.click();
        }, 400);
    }

    loadRetailerBalance = () => {


        var url = '/api/v1/account/balance/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(url + this.props.agentInfo.id, { headers }
        ).then((response) => {
            if (response.data.response.success == true) {
                var retailerBalanceVal = response.data.balance + response.data.creditLimit -
                    response.data.lien;
                this.setState({
                    retailerBalance: retailerBalanceVal
                })
                store.dispatch(setRetailerBalanceVal(retailerBalanceVal));

            }

        }).catch(error => {


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }


        });
    }
    goToAccountHistory = () => {
        var goToAccountHistory = document.getElementById('goToAccountHistory');
        goToAccountHistory.click();
    }


    render() {


        return (


            <div class="menu">
                <Link to='/account-history'>
                    <button id='goToAccountHistory' hidden={true}></button>
                </Link>
                <ul>
                    {process.env.REACT_APP_SHOW_DMT == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'dashBoard' && 'active'}>
                            <Link to='/dmt'>
                                <button type="button"><i class="bank"></i> Money Transfer</button>
                            </Link>

                        </li>
                    }
                    {process.env.REACT_APP_SHOW_BILLPAY == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'billPay' && 'active'}>
                            <Link to='/billPay'>
                                <button type="button" ><i class="bbps"></i> Bill Payment</button>
                            </Link>
                        </li>}
                       
                    {process.env.REACT_APP_SHOW_RECHARGE == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'recharge' && 'active'}>
                            <Link to='/recharge'>
                                <button type="button" ><i class="recharge"></i> Recharge</button>
                            </Link>
                        </li>
                    }
                    {process.env.REACT_APP_SHOW_PAYOUT == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'merchant-payout' && 'active'}>
                            <Link to='/merchant-payout'>
                                <button type="button" ><i class="merchant"></i> Merchant Payout</button>
                            </Link>
                        </li>
                    }
                    {process.env.REACT_APP_SHOW_AEPS == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'aeps' && 'active'}>

                            <button type="button" onClick={this.goToAeps} ><i class="aeps"></i> AePS</button>

                        </li>
                    }
                    {process.env.REACT_APP_SHOW_KYC == 'yes' &&
                        this.props.agentInfo.status != 'BANK_KYC_COMPLETE' &&
                        <li class={this.props.selectedMenuItem == 'kyc' && 'active'}>
                            <Link to='/merchant-onboard'>
                                <button type="button" ><i class="comsts"></i> Kyc</button>
                            </Link>
                        </li>
                    }
                    <Link to='/aeps'>
                        <button id='gotoAepsBtn' hidden={true} ></button>
                    </Link>

                    {this.props.retailerBalanceShow == 'yes' &&
                        <div class="tamnt">
                            <i class="ta" onClick={this.goToAccountHistory}>
                            </i> ₹ {parseFloat(this.state.retailerBalance)}
                            <Link to='/claim-upload'>
                                <button type="button" class="btn dbbtn">Claim</button>
                            </Link>
                        </div>
                    }
                </ul>

            </div>
        );
    }
}

const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, loginTime, partner,
        logoName, retailerBalanceShow,
        billpayshow,
        rechargeShow,
        aepsShow,
        dmtShow,
        payoutShow,
        kycShow }
    , authReduce: { callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, loginTime, partner,
    logoName,
    retailerBalanceShow,
    billpayshow,
    rechargeShow,
    aepsShow,
    dmtShow,
    payoutShow,
    kycShow,
    callBackUrl
});

export default connect(mapStateToProps, null)(Menu);